import {
  EXPORT_PRINT_STORE_DH_PROJECT,
  SAVE_PRINT_STORE_BRAND_KIT,
  SAVE_PRINT_STORE_DH_PROJECT
} from '@dtx-company/flow-codegen/src/code/mutations'
import { getPatchResultSaveBrandKit } from './printStore.utils'
import { printStoreApi } from './init'
import { sendSuccessNotification } from '../../../utils/notifications'
import { undoPatch } from './../flowcodeApiSlice/printStoreQueries.util.updateQueryData'
import type {
  ExportPrintStoreDhProjectMutation,
  ExportPrintStoreDhProjectMutationVariables,
  SavePrintStoreBrandKitMutation,
  SavePrintStoreBrandKitMutationVariables,
  SavePrintStoreDhProjectMutation,
  SavePrintStoreDhProjectMutationVariables
} from '@dtx-company/flow-codegen/src/code/generated.types'

export const printStoreMutations = printStoreApi.injectEndpoints({
  endpoints: builder => ({
    printStoreSaveBrandKit: builder.mutation<
      SavePrintStoreBrandKitMutation,
      SavePrintStoreBrandKitMutationVariables
    >({
      query: ({ brandKit }) => ({
        document: SAVE_PRINT_STORE_BRAND_KIT,
        variables: {
          brandKit: {
            logoImage: brandKit.logoImage,
            primaryText: brandKit.primaryText,
            primaryColor: brandKit.primaryColor,
            secondaryColor: brandKit.secondaryColor
          }
        },
        authOnly: true
      }),
      invalidatesTags: ['printStoreBrandKit'],
      async onQueryStarted(item, { dispatch, queryFulfilled }) {
        const patchResult = getPatchResultSaveBrandKit(item.brandKit, dispatch)
        try {
          await queryFulfilled
          sendSuccessNotification('Templates successfully updated')
        } catch {
          undoPatch(patchResult, 'Error saving Templates')
        }
      }
    }),

    printStoreExportProject: builder.mutation<
      ExportPrintStoreDhProjectMutation,
      ExportPrintStoreDhProjectMutationVariables
    >({
      query: variables => ({
        document: EXPORT_PRINT_STORE_DH_PROJECT,
        variables,
        authOnly: true
      }),
      invalidatesTags: []
    }),

    printStoreAssociateProject: builder.mutation<
      SavePrintStoreDhProjectMutation,
      SavePrintStoreDhProjectMutationVariables
    >({
      query: ({ dhProjectId, dhUserId, projectTitle, sourceTemplateId }) => ({
        document: SAVE_PRINT_STORE_DH_PROJECT,
        variables: { dhProjectId, dhUserId, projectTitle, sourceTemplateId },
        authOnly: true
      }),
      invalidatesTags: []
    })
  })
})

export const {
  usePrintStoreSaveBrandKitMutation,
  usePrintStoreExportProjectMutation,
  usePrintStoreAssociateProjectMutation
} = printStoreMutations
